<template>
	<div class="tw-gap-2 tw-flex tw-flex-col tw-h-full">
		<p-card>
			<p-multi-select
				prop="name"
				:options="jobAreas"
				:selected-options="selectedAreas"
				placeholder="Selecciona el area"
				@onChange="onGroupSelectionChange($event)"
				style="width: 500px; max-width: 100%"
			/>
		</p-card>
		<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between">
			<p-empty-message v-if="!jobs.length">
				Seleccione las áreas de los puestos
			</p-empty-message>
			<div v-if="!!jobs.length" class="tw-grid tw-grid-col tw-grid-cols-5 tw-gap-4 ">
				<square-box
					v-for="(jobItem, index) in jobs"
					:name="jobItem.name"
					theme="secondary"
					:checked="isSelectedJob(jobItem)"
					:key="index"
					:clickable="true"
					:display-actions="false"
					@click="onJobClick(jobItem)"
				></square-box>
			</div>
			<div>
				<p-horizontal-divider />
				<div class="tw-text-center">
					<p-button
						:disabled="selectedJobs.length < 1"
						@click="goToNextStep()"
						type="secondary"
						:extended="true"
						>Siguiente</p-button
					>
				</div>
			</div>
		</p-card>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { pathOr, filter, forEach } from 'ramda';
import MultiSelect from 'multiselect-dl';
import PCard from '../../../shared/components/ui/Card/p-card';
import PButton from '../../../shared/components/ui/p-button';
import PHorizontalDivider from '../../../shared/components/ui/p-horizontal-divider';
import SquareBox from '../../../shared/components/content/SquareBox';
import { getIds, tseNamespace } from '../../utils';
import PMultiSelect from '../../../shared/components/ui/p-multi-select';
import PEmptyMessage from '../../../shared/components/ui/p-empty-message';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from '../../store/store.constant';
import { findIndexElementInList } from '../../../shared/utils/listElements';

export default {
	name: 'choose-the-job',
	components: {
		PEmptyMessage,
		PMultiSelect,
		SquareBox,
		PHorizontalDivider,
		PButton,
		PCard,
		MultiSelect,
	},
	data() {
		return {
			selectedAreas: [],
			searchRef: null,
		};
	},
	async mounted() {
		await this.$store.dispatch(tseNamespace('getJobsAreas'));
	},
	methods: {
		goToNextStep() {
			this.$store.dispatch(tseNamespace('nextStep'));
		},
		onJobClick(job) {
			this.$store.dispatch(tseNamespace('toggleJobSelection'), job);
		},
		onGroupSelectionChange(selectedItems) {
			clearTimeout(this.searchRef);
			this.searchRef = setTimeout(() => {
				this.selectedAreas = selectedItems;
			}, 1000);
		},
		getJobs(areaIds) {
			this.$store.dispatch(tseNamespace('getFilteredJobs'), areaIds).then();
		},
		isSelectedJob(job) {
			return getIds(this.selectedJobs || []).includes(job.id);
		},
		loadSelectedAreas(selectedAreas) {
			this.selectedAreas = filter(area => this.selectedAreaIds.includes(area.id), selectedAreas);
		},
		validateSelectedJobs(newJobList) {
			// eslint-disable-next-line
			forEach(selectedJob => {
				const jobIndex = findIndexElementInList(selectedJob, newJobList);
				if (jobIndex < 0) {
					this.$store.dispatch(tseNamespace('toggleJobSelection'), selectedJob);
				}
			}, this.selectedJobs);
		},
	},
	computed: {
		...mapState(THREE_SIXTY_EVALUATION_NAMESPACE, {
			jobs: pathOr([], ['jobs']),
			jobAreas: pathOr([], ['jobAreas']),
			selectedAreaIds: pathOr([], ['evaluationFlow', 'selectedAreaIds']),
			selectedJobs: pathOr([], ['evaluationFlow', 'selectedJobs']),
		}),
	},
	watch: {
		jobAreas: {
			handler(newValue) {
				this.loadSelectedAreas(newValue);
			},
		},
		selectedAreas: {
			handler(newValue) {
				const areaIds = getIds(newValue);
				this.$store.dispatch(tseNamespace('updateSelectedAreasIds'), areaIds);
				this.getJobs(areaIds);
			},
		},
		jobs(newJobList) {
			this.validateSelectedJobs(newJobList);
		},
	},
};
</script>

<style lang="scss" scoped>
.choose-job-select {
	width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/first-step/choose-the-job.vue